import { render, staticRenderFns } from "./PayDetail.vue?vue&type=template&id=5c1fee8e&scoped=true"
import script from "./PayDetail.vue?vue&type=script&lang=js"
export * from "./PayDetail.vue?vue&type=script&lang=js"
import style0 from "./PayDetail.vue?vue&type=style&index=0&id=5c1fee8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1fee8e",
  null
  
)

export default component.exports